import { wrapError } from "utils/errorHelper";
import type { Dispatch } from "redux";

export default class ActionCreator<TData = unknown> {
  type: string;

  constructor(type: string) {
    this.type = type;
  }

  request(data?: unknown) {
    return {
      type: `${this.type}_REQUEST`,
      data,
    };
  }

  success(data: TData) {
    return {
      type: `${this.type}_SUCCESS`,
      data,
      success: true as const,
    };
  }

  failure(error: unknown) {
    return {
      type: `${this.type}_FAILURE`,
      error: wrapError(error),
      success: false as const,
    };
  }

  /**
   * Dispatches every action around the service response (promise).
   * @param dispatch
   * @param promise
   * @returns {*}
   */
  dispatchFullLifecycle(
    dispatch: Dispatch,
    promise: Promise<TData>,
    requestData?: unknown,
    callback?: (data: TData) => void
  ) {
    dispatch(this.request(requestData));
    return promise
      .then(
        (data) => {
          if (callback) {
            callback(data);
          }
          return dispatch(this.success(data));
        },
        (error) => dispatch(this.failure(error))
      )
      .catch((error) => dispatch(this.failure(error)));
  }
}
